let httpApp={
  getUserInfo : {  //获取用户信息
    value:'duchuang.getUserInfo',  //名称
    callObject:{   //返回值
      userId:null,  //用户ID
      userEntNo:null,  //企业ID
      userNickName:null, //用户名
      useType:null, //登录之后的管理员 用户
      userEntName: null, //属于企业
      headImg: null, //用户头像
      phoneNum:null,   //用户电话号码
      loginType:null,   //03未登录 02登录 01匿名登录  //不等于2表示未登入
      token:null,   //token
    }
  },
  toLogin:{  //唤起登入
    value:'duchuang.toLogin',   //唤起APP的登入
    callObject:{  //返回值
       v : null  // v不等于-1，代表登录成功 v != "-1"
    }
  },
  getDeviceType:{  //判断是否是在app里面打开  dsBridge.hasNativeMethod("duchuang.getDeviceType")
    value:'duchuang.getDeviceType',
    callObject:false  // 用于判断是否具有这个方法，不具有则不再app里面
  },
  onPageStarted:{
    value:'duchuang.onPageStarted',
    callObject:{},
    options:{  //需要传值
      id:null,
      title:null,
      url:null,
      img:null,
      summary:null
    }
  },
  share:{
	   value:'duchuang.share',
	   callObject:{},
	   options:{  //需要传值
	     id:null,
	     title:null,
	     url:null,
	     img:null,
	     summary:null
	   }
  },
  closeWin:{  //关闭当前页面
	   value:'duchuang.closeWin'
  },
	setTitles: { //关闭当前页面
		value: 'duchuang.setTitle',
		options: { //需要传值
			title: null,
		}
	},
	openDcPage:{
		value: 'duchuang.openDcPage',
		options: { //需要传值
			title: null,
		}
	}
}

export default httpApp



// WEBPACK FOOTER //
// ./src/api/dsApp.js